export const ONBOARDING_EVENT_STEP_COMPLETED = 'step completed';

export const enum OnboardingEventStepCompletedType {
  ManuallyCompleted = 'manually-completed',
  Skipped = 'skipped',
}
